/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_HlsInputs */

const en_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading HLS Manifest...`)
};

const fr_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du manifeste HLS...`)
};

const de_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS-Manifest wird geladen...`)
};

const it_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del manifesto HLS in corso...`)
};

const ru_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка манифеста HLS...`)
};

const es_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando manifiesto HLS...`)
};

const zh_cn2_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载 HLS 清单...`)
};

const ja_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS マニフェストを読み込んでいます...`)
};

const hi_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS मैनिफेस्ट लोड हो रहा है...`)
};

const pt_pt2_load_project_file_status_loading_hls = /** @type {(inputs: Load_Project_File_Status_Loading_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o manifesto HLS...`)
};

/**
* | output |
* | --- |
* | "Loading HLS Manifest..." |
*
* @param {Load_Project_File_Status_Loading_HlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_hls = /** @type {((inputs?: Load_Project_File_Status_Loading_HlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_HlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_loading_hls(inputs)
	if (locale === "de") return de_load_project_file_status_loading_hls(inputs)
	if (locale === "it") return it_load_project_file_status_loading_hls(inputs)
	if (locale === "ru") return ru_load_project_file_status_loading_hls(inputs)
	if (locale === "es") return es_load_project_file_status_loading_hls(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_loading_hls(inputs)
	if (locale === "ja") return ja_load_project_file_status_loading_hls(inputs)
	if (locale === "hi") return hi_load_project_file_status_loading_hls(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_loading_hls(inputs)
	return en_load_project_file_status_loading_hls(inputs)
});